//Get the distance from an element to the top of the document
export const getOffsetTop = function (elem) {
	// Set our distance placeholder
	var distance = 0;

	// Loop up the DOM
	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}

	// Return our distance
	return distance < 0 ? 0 : distance;
};

export const isWoocommerceUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/checkout', '/cart', '/product/', 'gifts/account'];
	return substrings.some(urlHasSubstring);
};

export const isAdminUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/wp-admin'];
	return substrings.some(urlHasSubstring);
};


//Set, get & delete cookies
export const setCookie = (name,value,days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export const  getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export const  eraseCookie = (name) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}